import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import {
  NotificationSetting,
  UpdateNotificationSetting,
  NotificationGroupOption,
  ServiceGroupRecipient
} from '../models/notification-setting.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationSettingService {
  private apiUrl = `${environment.apiUrl}/NotificationSetting`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<NotificationSetting[]> {
    return this.http.get<NotificationSetting[]>(this.apiUrl).pipe(retry(2));
  }

  getGroupOptions(): Observable<NotificationGroupOption[]> {
    return this.http.get<NotificationGroupOption[]>(`${this.apiUrl}/groups`).pipe(retry(2));
  }

  getServiceGroupRecipients(): Observable<ServiceGroupRecipient[]> {
    return this.http.get<ServiceGroupRecipient[]>(`${this.apiUrl}/service-groups`).pipe(retry(2));
  }

  updateServiceGroupRecipients(id: string, notificationEmails: string): Observable<ServiceGroupRecipient> {
    return this.http.put<ServiceGroupRecipient>(
      `${this.apiUrl}/service-groups/${id}`, { notificationEmails });
  }

  update(id: string, dto: UpdateNotificationSetting): Observable<NotificationSetting> {
    return this.http.put<NotificationSetting>(`${this.apiUrl}/${id}`, dto);
  }

  setMaster(enabled: boolean): Observable<NotificationSetting> {
    return this.http.put<NotificationSetting>(`${this.apiUrl}/master?enabled=${enabled}`, {});
  }
}
